/** @format */

import { min } from 'rxjs';

export function getFileNameFromPath(path: string) {
  let index = Math.max(path.lastIndexOf('\\'), path.lastIndexOf('/'));
  if (index >= 0) {
    return path.substring(index + 1);
  } else {
    return path;
  }
}
